/**
 * Created by zhyp on 2015/9/06.
 */
'use strict';
angular.module('pieceMgr.multiImgsDir', [])
    .directive('trsFragImgs', ['$modal', '$filter', 'trsSelectDocumentService', 'fragmentService', 'modalDialog', function($modal, $filter, trsSelectDocumentService, fragmentService, modalDialog) {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: './editingCenter/website/fragmentManagement/multipleImages/mImages.html',
            transclude: true,
            scope: {
                jsonObj: '=',
                widgetParams: '=',
                index: '@',
                required: '@',
                siteid: '@'
            },
            controller: function($scope, $timeout, $element) {
                // 新增条目
                $scope.addItem = function() {
                    if (!$scope.list) {
                        $scope.list = [];
                    }
                    $scope.list.unshift({});
                };
                // 全选
                $scope.selectAll = function() {
                    $scope.selectedArray = $scope.selectedArray.length == $scope.list.length ? [] : [].concat($scope.list);
                };
                // 删除条目
                $scope.deleteItem = function(item, record) {
                    $scope.list.length && $scope.list.splice(record, 1);
                    angular.forEach($scope.selectedArray, function(data, index) {
                        if (data == item) {
                            $scope.selectedArray.splice(index, 1);
                        }
                    });
                };
                // 批量删除
                $scope.deleteMultiItems = function() {
                    modalDialog.confirmModal('删除', '是否确认删除选择的稿件', function() {
                        var temp = [];
                        angular.forEach($scope.list, function(data, index, array) {
                            if ($scope.selectedArray.indexOf(data) > -1) {
                                temp.push(index);
                            }
                        });
                        var count = 0;
                        angular.forEach(temp, function(data, index) {
                            data = data - count;
                            $scope.list.splice(data, 1);
                            count++;
                        });
                        $scope.selectedArray = [];
                    });
                };
                // 清空标题
                $scope.cleanInput = function(index) {
                    $scope.list[index].title = '';
                };
                // 关闭弹框
                $scope.closeUp = function() {
                    $scope.$parent.$close();
                };
                // h5拖拽开始
                $scope.dragoverCallback = function(event, index, external, type) {
                    // Disallow dropping in the third row. Could also be done with dnd-disable-if.
                    return index < 10;
                };

                $scope.dropCallback = function(event, index, item, external, type, allowedType) {
                    if (external) {
                        if (allowedType === 'colType' && !item.label) {return false;}
                        if (allowedType === 'rowType' && !angular.isArray(item)) {return false;}
                    }
                    return item;
                };
                $scope.dragStart = function() {
                    angular.forEach($scope.list, function(data, index, array) {
                        $scope.list[index].showMe = false;
                    });
                };
                $scope.dragMoved = function(index) {
                    $scope.list.splice(index, 1);
                    angular.forEach($scope.list, function(data, index, array) {
                        $scope.list[index].$$hashKey = index;
                    });
                };
                // h5拖拽结束
            },
            link: function(scope, element, attrs, accordionController) {
                init();
                scope.showDocSel = function() {
                    var relNewsData = [];
                    angular.forEach(scope.list, function(data, index, array) {
                        if (angular.isDefined(data.isRelNews)) {
                            relNewsData.push({
                                TITLE: data.title,
                                HOMETITLE: data.subtitle,
                                TITLECOLOR: data.titlecolor,
                                ABSTRACT: data.abstract,
                                DOCPUBURL: data.url,
                                RECID: data.recid,
                                CRTIME: data.crtime,
                                SOURCE: data.source,
                                AUTHOR: data.author,
                                METADATAID: data.metadataId,
                                METALOGOURL: {
                                    PICSLOGO: data.imgsrc
                                }
                            });
                        }
                    });
                    scope.widgetParams.relNewsData = relNewsData;
                    scope.widgetParams.IsPicDoc = true;
                    scope.widgetParams.platform = 1;
                    trsSelectDocumentService.trsSelectDocument(scope.widgetParams, function(result) {
                        scope.list.splice(0, scope.list.length);
                        result.forEach((item, index) => {
                            item.docid = item.metadataId;
                            scope.list.push(item);
                        });
                    });
                };
                scope.changeTime = function(time) {
                    time = $filter('date')(time, 'yyyy-MM-dd HH:mm').toString();
                    return time;
                };
                // 多选
                scope.selectDoc = function(item) {
                    if (scope.selectedArray.indexOf(item) < 0) {
                        scope.selectedArray.push(item);
                    } else {
                        scope.selectedArray.splice(scope.selectedArray.indexOf(item), 1);
                    }
                };

                function init() {
                    scope.list = scope.jsonObj;
                    scope.nowTime = fragmentService.getNowTime();
                    scope.selectedArray = [];
                }
            }
        };
    }]).directive('expander', ['$timeout', '$modal', 'editPictureService', '$filter', function($timeout, $modal, editPictureService, $filter) {

        /** 
         手风琴 <expader>，有一个属性 ver 用来传入子模版
        **/
        return {
            restrict: 'EA',
            replace: true,
            link: function(scope, element, attrs, accordionController, $timeout) {
                init();
                // $timeout(function() {
                scope.callBack = {
                    success: function(file, src) {
                        // $timeout(function() {
                        scope.item.imgsrc = src.imgSrc;
                        scope.item.imgName = src.imgName;
                        scope.uploaderSrc = src.imgSrc;
                        scope.uploaderSuccess = true;
                        scope.item.extField1 = '';
                        // });
                    },
                    error: function(file) {
                        var error = file;
                    },
                    file: function(file, uploader) {
                        // $timeout(function() {
                        scope.uploaderSuccess = false;
                        scope.uploadFileName = file[0].name;
                        // uploader.upload();
                        // });

                        angular.forEach(file, function(value, key) {
                            uploader.makeThumb(value, function(error, src) {});
                        });
                    },
                    tar: function(file, percentage) {
                        var per = Math.ceil(percentage * 100) + '%';
                        $timeout(function() {
                            scope.data.progress[file.id] = per;
                            scope.data.proGress[file.id] = Math.ceil(percentage * 100);
                        });
                    },
                    comp: function() {

                    },
                    start: function() {
                        // scope.data.errorNameArr = [];
                        scope.theFinish = function() {
                            uploader.upload();
                        };
                    },
                    finish: function() {

                    }
                };
                // });
                var path = attrs.ver;
                var index = attrs.index;
                scope.getContentUrl = function() {
                    return ' ./editingCenter/website/fragmentManagement/' + path + '.html';
                };
                scope.item.showMe = !!(angular.isUndefined(scope.item.showMe) || scope.item.showMe === true);
                scope.item.titleTip = angular.isUndefined(scope.item.titleTip) ? '收起' : scope.item.titleTip;
                scope.toggle = function toggle() {
                    scope.item.showMe = !scope.item.showMe;
                    scope.item.titleTip = scope.item.showMe ? '收起' : '展开';
                };

                function init() {
                    scope.data = {
                        proGress: {},
                        progress: {}
                    };
                    scope.requiredObj = {};
                    for (var i = 0; i < scope.required.split(',').length; i++) {
                        scope.requiredObj[scope.required.split(',')[i].replace(/ /g, '')] = true;
                    }
                    if (angular.isDefined(scope.item.reltime)) {
                        if (typeof scope.item.reltime === 'object') {
                            scope.item.reltime = $filter('date')(scope.item.reltime, 'yyyy-MM-dd HH:mm').toString();
                        } else if (typeof scope.item.reltime === 'string' && scope.item.reltime.indexOf('T') > -1) {
                            scope.item.reltime = scope.item.reltime.replace('T', ' ').split(':').splice(0, 2).join(':');
                        }
                    }
                }
                scope.modifyImg = function() {
                    var imgObj = {
                        PERPICURL: scope.item.imgsrc,
                        APPFILE: scope.item.imgName,
                        APPDESC: ''
                    };
                    editPictureService.editPicture(imgObj, scope.widgetParams.siteid, function(img) {
                        scope.item.imgName = img.imgName;
                        scope.uploaderSrc = scope.item.imgsrc = img.imgSrc;
                    });
                };
                scope.$watch('item.reltime', function(newV, oldV) {
                    if (newV != oldV) {
                        if (typeof scope.item.reltime === 'object') {
                            scope.item.reltime = $filter('date')(scope.item.reltime, 'yyyy-MM-dd HH:mm').toString();
                        } else if (newV.indexOf('T') > -1) {
                            scope.item.reltime = newV.replace('T', ' ').split(':').splice(0, 2).join(':');
                        }
                    }
                });
            },
            template: '<li ng-include="getContentUrl()" class="liChild"></li>'
        };
    }]);
